import { action } from "typesafe-actions";
import { IPoliticalRegimeActionTypes, IPoliticalRegime } from "./Types";

export const getPoliticalRegime = (token: string) => {
  return action(IPoliticalRegimeActionTypes.GET_POLITICAL_REGIME, token);
};
export const getPoliticalRegimeSuccess = (
  politicalRegimList: IPoliticalRegime[]
) => {
  return action(
    IPoliticalRegimeActionTypes.GET_POLITICAL_REGIME_SUCCESS,
    politicalRegimList
  );
};
export const getPoliticalRegimeFailure = (error: string) => {
  return action(
    IPoliticalRegimeActionTypes.GET_POLITICAL_REGIME_FAILURE,
    error
  );
};
